import { useTranslation } from "react-i18next";

export default function PresentationSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-gradient-to-br from-background-950 via-background-900 to-background-800 py-14 md:py-20">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <h2 className="font-heading text-xl md:text-2xl lg:text-3xl font-bold text-background-50 mb-8 md:mb-10 leading-relaxed">
          {t("presentation.heading")}
        </h2>

        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 md:gap-x-12 gap-y-3 md:gap-y-4">
          {(t("presentation.items", { returnObjects: true }) as string[]).map((item: string, index: number) => (
            <li
              key={index}
              className="flex items-start gap-3 text-sm md:text-base text-background-50/80 leading-relaxed"
            >
              <span className="mt-1.5 md:mt-2 flex-shrink-0 w-1.5 h-1.5 rounded-full bg-primary-400"></span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}